import {Component, Inject} from '@angular/core';
import {AppRoutes} from "../../enums/routes";
import {AuthenticationService} from "../../_auth/authentication.service";
import {CookieService} from "../../_services/cookie.service";
import {CookieType} from "../../x-models/x-enums/cookie-type";
import {OwnerRoutes} from "../../_modules/owner/_models/_enums/owner-routes";
import {CompanyRoutes} from "../../_modules/company/x-models/x-enums/company-routes";
import {Constants} from "../../constants";
import {NavbarItemLargeComponent} from "../navbar-base/navbar-item-large/navbar-item-large.component";
import {NavbarItemSmallComponent} from "../navbar-base/navbar-item-small/navbar-item-small.component";
import {
  NavbarItemSmallContainerComponent
} from "../navbar-base/navbar-item-small-container/navbar-item-small-container.component";
import {NavbarContainerComponent} from "../navbar-base/navbar-container/navbar-container.component";

@Component({
  selector: 'app-navbar-owner',
  templateUrl: './navbar-owner.component.html',
  imports: [
    NavbarItemLargeComponent,
    NavbarItemSmallComponent,
    NavbarItemSmallContainerComponent,
    NavbarContainerComponent
  ],
  styleUrls: ['./navbar-owner.component.scss']
})
export class NavbarOwnerComponent {
  protected readonly Routes = AppRoutes;
  protected readonly OwnerRoutes = OwnerRoutes;
  // The Zugänge screen lives in the company module, but a platform principal has no company and therefore no
  // Unternehmen tab (NavbarService.PlatformLevelTitles hides it), so the one route is linked from here too.
  protected readonly CompanyRoutes = CompanyRoutes;

  constructor(private authenticationService: AuthenticationService, @Inject("BASE_URL") private baseUrl: string,
              private cookieService: CookieService) {
  }

  openHangfireDashboard(): void {
    this.cookieService.setCookie(CookieType.Required, Constants.Cookies.Hangfire, this.authenticationService.userValue!.jwt, 7, "/; domain=" + document.location.hostname);
    if (this.baseUrl.indexOf('localhost') > -1) {
      window.open(this.baseUrl + "/scheduling/service", "_blank");
    } else {
      window.open(location.origin + "/scheduling/service", "_blank");
    }
    //location.replace(location.host + "/hangfire");
  }
}
